<script setup lang="ts">
import { ChevronDown } from "@lucide/vue";
import { SelectIcon, SelectTrigger, type SelectTriggerProps } from "radix-vue";
import { type ClassNameValue, twMerge } from "tailwind-merge";

const props = defineProps<SelectTriggerProps>();
</script>

<template>
	<SelectTrigger
		v-bind="props"
		:class="
			twMerge([
				'flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1',
				$attrs.class as ClassNameValue[],
			])
		"
	>
		<slot />
		<SelectIcon as-child>
			<ChevronDown class="size-4 opacity-50" />
		</SelectIcon>
	</SelectTrigger>
</template>
